import React from 'react';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { DATE_FORMAT } from 'framework/utils';
import { Collapsible, DateField, CommaListField } from 'framework/ui/field';
import { BUDGET_OBJECTIVE_UNIT_OPTIONS } from '../budgetVersionService';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { BUDGETING_CREATE_STRUCTURE } from 'domain/organization/serviceCatalog/budgets/budgetingService';
import { ShowSection } from 'framework/ui/layout';
import { useShowContext } from 'framework/show';

const ServiceCostsStructureRecordLayout = ({ onEdit, ...props }: any) => {
  const formatObjective = (objective: any) => {
    return `${objective.name} (${BUDGET_OBJECTIVE_UNIT_OPTIONS[objective.unit]})`;
  };
  const buttons = [<EditTimelineRecordButton onEdit={onEdit} permissionToCheck={BUDGETING_CREATE_STRUCTURE} />];

  const { data } = useShowContext();

  return (
    <BaseTimelineRecordLayout
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      entity={data}
      {...props}
      fields={
        <Collapsible>
          <ShowSection>
            <DateField label="Effective Date" source="effectiveDate" dateFormat={DATE_FORMAT.API_ONLY_MONTH} />
            <CommaListField label="Categories" source="categories" />
            <CommaListField label="Objectives" source="objectives" mapValue={formatObjective} />
          </ShowSection>
        </Collapsible>
      }
    />
  );
};

export default ServiceCostsStructureRecordLayout;
